module.exports = __webpack_public_path__ + "static/media/Founders_Grotesque.da63a43c.ttf";